// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$BenfaerberBlog from "../Translation.bs.js";

function s(prim) {
  return prim;
}

function Flag(props) {
  var __className = props.className;
  var onClick = props.onClick;
  var language = props.language;
  var className = __className !== undefined ? __className : "";
  var name = Translation$BenfaerberBlog.languageToString(language);
  var src = "../images/flags/" + name + ".png";
  var alt;
  alt = language === "English" ? "English" : "German";
  var handleClick = function (param) {
    if (onClick !== undefined) {
      return onClick();
    }
    
  };
  return JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx("img", {
                    alt: alt,
                    src: src
                  }),
              className: "flag " + className,
              onClick: handleClick
            });
}

var make = Flag;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
